import api from '../api';
import { cutPosterUrl, cutPreviewUrl } from './newNle';
import { preloadHlsEngine } from '../components/NleHlsPreview';

let warmed = null;

export function nlePlaylistCacheKey(cutIds, fastPacing, flipbookIntro) {
  return `${fastPacing ? 1 : 0}:${flipbookIntro ? 1 : 0}:${(cutIds || []).map(String).join(',')}`;
}

export function peekWarmedHls(key) {
  if (!key || !warmed || warmed.key !== key) return null;
  if (warmed.mode !== 'hls' || !(warmed.playlistUrl || warmed.playlist)) return null;
  return warmed;
}

export function prefetchVoiceover(url) {
  const src = String(url || '').trim();
  if (!src || typeof Audio === 'undefined') return;
  try {
    const audio = new Audio();
    audio.preload = 'auto';
    audio.src = src;
  } catch (_) {}
}

export function prefetchMediaUrls(urls, limit = 12) {
  const list = [...new Set((urls || []).map((u) => String(u || '').trim()).filter(Boolean))].slice(0, limit);
  list.forEach((url) => {
    if (/\.(png|jpe?g|webp|gif|avif)(\?|$)/i.test(url) || /thumbnail|thumb|poster/i.test(url)) {
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
      return;
    }
    fetch(url, { mode: 'cors', credentials: 'omit', cache: 'force-cache' }).catch(() => {});
  });
}

export function prefetchHlsSegments(playlistText, limit = 8) {
  if (!playlistText) return;
  const segs = [];
  String(playlistText).split(/\r?\n/).forEach((raw) => {
    const line = raw.trim();
    if (line && !line.startsWith('#') && segs.length < limit) segs.push(line);
  });
  prefetchMediaUrls(segs, limit);
}

export function prefetchCutPreviewAssets(cuts, { posterLimit = 16, proxyLimit = 6 } = {}) {
  prefetchMediaUrls((cuts || []).map((c) => cutPosterUrl(c)), posterLimit);
  prefetchMediaUrls((cuts || []).map((c) => cutPreviewUrl(c)), proxyLimit);
}

export async function warmNleHlsPlaylist({ workspaceId, orderedCutIds, fastPacing, flipbookIntro }) {
  const ids = (orderedCutIds || []).map(String).filter(Boolean);
  if (!workspaceId || !ids.length) return null;
  const key = nlePlaylistCacheKey(ids, fastPacing, flipbookIntro);
  const existing = peekWarmedHls(key);
  if (existing) {
    prefetchHlsSegments(existing.playlist, 8);
    return existing;
  }
  preloadHlsEngine();
  const result = await api.requestWorkspaceNleHlsPlaylist(workspaceId, {
    orderedCutIds: ids,
    fastPacing: !!fastPacing,
    flipbookIntro: !!flipbookIntro,
  });
  const data = result?.data || result;
  if (data?.mode === 'hls' && (data.playlistUrl || data.playlist)) {
    warmed = {
      key,
      mode: 'hls',
      playlistUrl: data.playlistUrl || '',
      playlist: data.playlist || '',
    };
    prefetchHlsSegments(data.playlist, 8);
    return warmed;
  }
  warmed = { key, mode: data?.mode || 'progressive', playlistUrl: '', playlist: '' };
  return warmed;
}
